export const departmentTag = 'department:';
